module.exports = __webpack_public_path__ + "static/5-1bae861d4c7c93f9ca1790ea71142d00.jpeg";